import {Role} from "src/_generated/typed-document-nodes-common"
import {localStorageItemName} from "src/constants/local-storage-item-name"

import CommonUtils from "../Common"

type RoleWithToken = Role & {token: string}

const getTenant = (): RoleWithToken | undefined => {
    const raw = CommonUtils.GetLocal(localStorageItemName.selectedRole)
    if (!raw) return undefined
    try {
        return JSON.parse(raw)
    } catch {
        return undefined
    }
}

const getTenantId = (): string | undefined => {
    return getTenant()?.tenantId
}

const getTenantName = (): string | undefined => {
    return getTenant()?.tenantName
}

export {getTenantId, getTenantName}
